var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "voipBox"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.$t('operationBtn.voipTips'),
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "iconfont pointer",
    class: _vm.VoIPStatusClass,
    on: {
      "click": _vm.configVoIP
    }
  })]), _c('audio', {
    ref: "voipAudio",
    staticClass: "hide",
    attrs: {
      "controls": "",
      "autoplay": ""
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };